/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminTransactionsService {
    /**
     * List transactions
     * Retrieve a paginated list of transactions with search, filters by status, type, and payment method.
     * @param search Free text search over transaction number, client/expert name, or gateway ID
     * @param statuses Filter by one or more payment statuses
     * @param transactionTypes Filter by one or more transaction types
     * @param paymentMethods Filter by one or more payment methods
     * @param dateFrom Filter transactions on/after this date (ISO 8601)
     * @param dateTo Filter transactions on/before this date (ISO 8601)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns any Transactions fetched successfully
     * @throws ApiError
     */
    public static adminTransactionsControllerFetchTransactionsV1(
        search?: string,
        statuses?: Array<'pending' | 'completed' | 'failed' | 'refunded'>,
        transactionTypes?: Array<'booking_payment' | 'subscription_fee' | 'addon_purchase' | 'refund' | 'payout'>,
        paymentMethods?: Array<'stripe' | 'tabby' | 'in_app_purchase' | 'amazon_pay'>,
        dateFrom?: string,
        dateTo?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/transactions',
            query: {
                'search': search,
                'statuses': statuses,
                'transactionTypes': transactionTypes,
                'paymentMethods': paymentMethods,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get transaction detail
     * Get full transaction detail including related booking, client, expert info, and payment events.
     * @param id Transaction UUID or transaction number
     * @returns any Transaction detail retrieved
     * @throws ApiError
     */
    public static adminTransactionsControllerGetTransactionDetailV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/transactions/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Transaction not found`,
            },
        });
    }
}
